import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import InformationsListView from "./informations-list.html";
import InformationsEditView from "./informations-edit.html";


angular.module("informations", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
           .state('informations', {
                url: "/informations",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
                cache: false,
            })
            .state('informations.list', {
                url: "/list",
                controller: "InformationsListCtrl",
                template: InformationsListView,
                data: { pageTitle: 'Memoria' },
                cache: false,
                requiredPermission: ["INFORMATION_READ"]
            })
            .state('informations.edit', {
                url: "/edit/:information_id",
                controller: "InformationsEditCtrl",
                template: InformationsEditView,
                data: { pageTitle: 'Memoria' },
                cache: false,
                requiredPermission: ["INFORMATION_READ"]
            })
        ;
    }])
;